export const UNPAID_STATUSES = [
  "REJECTED",
  "EXCEEDED_PAYMENT_RETRIES",
  "DISPUTED",
  // Q1 auditoría 2026-08-09: una disputa PERDIDA es deuda viva (el chargeback
  // retiró el dinero). El estado lo escribe ms-payment desde el 7-ago; sin
  // esta entrada, perder la disputa hacía desaparecer el recibo de la pantalla.
  "DISPUTE_LOST",
  "REJECTED_PAUSED",
] as const;

export type UnpaidStatus = (typeof UNPAID_STATUSES)[number];

export const PAYMENT_METHOD_TYPES = ["card", "sepa"] as const;
export type PaymentMethodType = (typeof PAYMENT_METHOD_TYPES)[number];

export const PAYMENT_METHOD_LABEL: Record<PaymentMethodType, string> = {
  card: "Tarjeta",
  sepa: "SEPA",
};

export const PAYMENT_METHOD_STYLES: Record<
  PaymentMethodType,
  { bg: string; fg: string }
> = {
  card: { bg: "#e3f2fd", fg: "#0d47a1" },
  sepa: { bg: "#f3e8ff", fg: "#6f42c1" },
};

export type UnpaidInvoiceRow = {
  invoiceId: string;
  invoiceDate: string | null;
  ageDays: number | null;
  annuality: number | null;
  invoiceNumber: number | null;
  rawPrice: number | null;
  finalPrice: number | null;
  status: UnpaidStatus | string;
  subscriptionId: string | null;
  subscriptionStatus: string | null;
  carrier: string | null;
  defaultPaymentMethod: string | null;
  paymentMethodType: PaymentMethodType | null;
  /** 4 últimos dígitos (espejo local; verdad-Stripe llegará vía R11). */
  paymentMethodLast4?: string | null;
  leadId: number | null;
  leadUlid: string | null;
  leadEmail: string | null;
  leadName: string | null;
  leadMarket: string | null;
  leadStatus: string | null;
  policyNumber: string | null;
  stripeCustomerId: string | null;
  leadUnpaidCount: number;
};

export type UnpaidInvoicesResponse = {
  rows: UnpaidInvoiceRow[];
  total: number;
  limit: number;
  offset: number;
  aggregates: {
    totalAmount: number;
    countsByStatus: Partial<Record<UnpaidStatus, number>>;
  };
};

export const UNPAID_STATUS_LABEL: Record<UnpaidStatus, string> = {
  REJECTED: "Rechazada",
  EXCEEDED_PAYMENT_RETRIES: "Reintentos agotados",
  DISPUTED: "Disputada",
  DISPUTE_LOST: "Disputa perdida",
  REJECTED_PAUSED: "Rechazada (pausada)",
};

export const UNPAID_STATUS_STYLES: Record<
  UnpaidStatus,
  { bg: string; fg: string }
> = {
  REJECTED: { bg: "#fde2e2", fg: "#b32424" },
  EXCEEDED_PAYMENT_RETRIES: { bg: "#7c1d1d", fg: "white" },
  DISPUTED: { bg: "#f3e8ff", fg: "#6f42c1" },
  DISPUTE_LOST: { bg: "#4a1d6f", fg: "white" },
  REJECTED_PAUSED: { bg: "#fff3cd", fg: "#856404" },
};
